import React from 'react'
import "../../CSS/Blog/Adstxt.css"
import FooTer from "../footer"
import adstxt from "../../Images/Blog/ads.txt.jpg"
export default function Adstxt() {
    return (
        <>
            <h1 id="start">Fixing ads.txt error from Backend</h1>
            <hr />
            <h1 className="hd">How To Fix ads.txt Error Issue In Backend</h1>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/DZd_7UilG_s" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <p className='subs'>
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) Node JS<br />
                2) ads.txt File<br />
                3) Filezila<br />
                4) Linux C-Panel<br />
                5) Putty<br />
            </p>
            <p className="q">
                What Is ads.txt error Issue?
            </p>
            <p className="ans">
                ads.txt error issue is a issue where anytype of Google Adsense Approved user first time they saw that showing a error on main screen for fix it and if they not will fix this so it's says that it will impact on ads revenue.
            </p>
            <p className="q">
                Main Concent Of This Page..
            </p>
            <p className="ans">
                Everyone could be watch that everywhere using blogspot or wordpress or anything videos happenes but in this site i told how it's work in backend like node JS, Python - DJANGO,FLASK etc. Backend site so fix this issue in your backend and stay tunes also Happy Earning.
            </p>
            <p className="q">
                :: Look At A Step Closer About That Issue ::
            </p>
            <div className="zip-downloader">
                <img src={adstxt} alt="loading" />
            </div>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer/>
        </>
    )
}
